import { defineStore } from "pinia";
import { ClientesApi, ComparecientesApi } from "@/api";
import { useUIStateStore } from ".";

import Storage from "@/utils/storage";

const storage = new Storage();

export const useComparecientesComboStore = defineStore("comparecientesCombo", {
  state: () => ({
    comparecientes: [],
    alreadyFetched: false,
  }),
  getters: {
    getSelectOptions() {
      return this.comparecientes.map((c, i) => {
        let nombre = "";

        if (c.persona === "Moral") {
          nombre = c.denominacion_social + " (Persona moral)";
        } else if (c.persona === "Fideicomiso") {
          nombre = c.denominacion_social + " (Fideicomiso)";
        } else {
          nombre = `${c.nombre} ${c.paterno} ${c.materno || ""}`.trimEnd() + " (Persona física)";
        }

        return {
          id: c.id,
          index: i + 1,
          text: nombre
        }
      });
    },
  },
  actions: {
    async fetchCombo() {
      const uiState = useUIStateStore();

      uiState.startLoading();

      const clienteEmail = storage.getItem("user");
      const { id } = await ClientesApi.clienteId(clienteEmail);
      const { value } = await ComparecientesApi.combo({
        clientes_id: id,
      });

      this.comparecientes = value;

      uiState.stopLoading();
    },
  },
  persist: false,
});
